import { SrcNotificationSetting } from '../../../projects/client/apis/src-notification-settings/src-notification-settings.model';

export const SRC_NOTIFICATION_TYPE = 'SrcDeviceOffline';

export const DEFAULT_THRESHOLD = '01:00:00';

export const DELAY_OPTIONS: { label: number; value: string }[] = [
  { label: 15, value: '00:15:00' },
  { label: 30, value: '00:30:00' },
  { label: 45, value: '00:45:00' },
  { label: 60, value: '01:00:00' },
  { label: 120, value: '02:00:00' },
  { label: 180, value: '03:00:00' },
  { label: 240, value: '04:00:00' },
  { label: 360, value: '06:00:00' },
  { label: 480, value: '08:00:00' },
  { label: 720, value: '12:00:00' },
  { label: 1440, value: '24:00:00' },
];

export interface SrcNotificationSettingsState {
  data: SrcNotificationSetting | null;
  loading: boolean;
  loaded: boolean;
  error: string | null;
}
